import axios from 'axios';

export default {
  getList(_, params) {
    return axios.get('StaffExpedition/GetList', { params });
  },
  reject(_, id) {
    return axios.get('StaffExpedition/Reject', { params: { id } });
  },
  approve(_, id) {
    return axios.get('StaffExpedition/Approve', { params: { id } });
  },
};
